import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSell = (props, ref) => (React.createElement("svg", { width: 24, height: 24, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M570-104q-23 23-57 23t-57-23L104-456q-11-11-17.5-26T80-514v-286q0-33 23.5-56.5T160-880h286q17 0 32 6.5t26 17.5l352 353q23 23 23 56.5T856-390zm-57-56 286-286-353-354H160v286zM260-640q25 0 42.5-17.5T320-700t-17.5-42.5T260-760t-42.5 17.5T200-700t17.5 42.5T260-640M160-800" })));
const ForwardRef = forwardRef(SvgSell);
const Memo = memo(ForwardRef);
export default Memo;
